import { render, staticRenderFns } from "./CategoryProductTable.vue?vue&type=template&id=289a089f&"
import script from "./CategoryProductTable.vue?vue&type=script&lang=js&"
export * from "./CategoryProductTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports